import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { Mechanism } from '../components/landing/Mechanism';
import { Included } from '../components/landing/Included';
import { Pricing } from '../components/landing/Pricing';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      f.fbq('init', '2625771897795800');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-149">
      {/* Navigation / Header */}
      <nav className="absolute top-0 left-0 right-0 z-50 py-6" data-id="element-150">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-151">
          <div className="flex items-center gap-2" data-id="element-152">
            <img src="https://cdn.magicpatterns.com/uploads/kmrXRrDuFm3Mi9V1ePQ3GT/logo_listo_pa_cenar.png" alt="Listo Pa' Cenar Logo" className="h-10 md:h-12 w-auto object-contain" data-id="element-153" />
          </div>
        </div>
      </nav>

      <main data-id="element-154">
        <Hero data-id="element-155" />
        <Problem data-id="element-156" />
        <Solution data-id="element-157" />
        <Mechanism data-id="element-158" />
        <Included data-id="element-159" />
        <Pricing data-id="element-160" />
      </main>

      <footer className="bg-stone-900 text-stone-400 py-12" data-id="element-161">
        <div className="container mx-auto px-4 text-center" data-id="element-162">
          <img src="https://cdn.magicpatterns.com/uploads/kmrXRrDuFm3Mi9V1ePQ3GT/logo_listo_pa_cenar.png" alt="Listo Pa' Cenar Logo" className="h-8 w-auto mx-auto mb-6 opacity-50 grayscale hover:grayscale-0 transition-all" data-id="element-163" />
          <p className="mb-4" data-id="element-164">
            &copy; {new Date().getFullYear()} Listo Pa' Cenar. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-165">
            <a href="#" className="hover:text-white transition-colors" data-id="element-166">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-167">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-168">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}